export const previewSamplesData = {
  itemNo: 'SKJCH-2100-1000-01'
};

export const previewDeviceData = {
  customCodes: '管理编号/出厂编号',
  devName: '设备名称',
  devModel: '型号',
  checkOrg: '校准检定单位',
  lsCheckTime: '校准检定时间',
  nxCheckTime: '使用期限',
  t6: '固定资产编号',
  customDeviceUrl: `${process.env.VUE_APP_H5_URL}/#/`
};

export const providerDeviceAdjustData = {
  t1: '（测试）基桩高应变检测仪',
  t2: '(test)SK-126/20211103007',
  t3: '(test)2024/10/30',
  t4: '(test)2025/10/29',
  t5: '（测试）交徽省计量科学研究院'
};

export const previewCertificateData = {
  itemName: '测试试样名称',
  model: '240KV',
  itemNo: 'SKJC-2080-0001-001/TEST24-1155',
  itemInterNo: '/',
  curTestDate: '2050-01-01',
  nextTestDate: '2100-01-01',
  otherMembers: '张三 李四',
  result: '不合格'
};
